

































































































































































import { Component, Vue } from 'vue-property-decorator'
import HeaderNavigationDropdown from '@/components/layout/header/navigation/HeaderNavigationDropdown.vue'
import HeaderNavigationItemTitle from '@/components/layout/header/navigation/HeaderNavigationItemTitle.vue'
import RouteName from '@/utils/RouteName'
import TranslationModule from '@/utils/TranslationModule'
import EvaIcon from '@/components/svg-components/EvaIcon.vue'
import { Header } from '@/types/Header.type'
import API from '@/services/API'
import { namespace } from 'vuex-class'
import { Member } from '@/types/Member.type'
import BaseIcon from '@/components/reusable-components/basics/BaseIcon.vue'

const User = namespace('user')

@Component({
    components: { EvaIcon, HeaderNavigationItemTitle, HeaderNavigationDropdown, BaseIcon },
})
export default class HeaderCommunityNavigation extends Vue {
    @User.State me!: Member
    RouteName: typeof RouteName = RouteName
    TranslationModule: typeof TranslationModule = TranslationModule
    groupLocationShow = ''
    secondariesHub: { id: string | number; name: string; slug: string; region: string }[] = []

    communityLinks = [
        { id: 'contacts', route: { name: RouteName.MEMBER_LIST_CONTACTS } },
        { id: 'favorites', route: { name: RouteName.MEMBER_LIST_FAVORITES } },
        { id: 'suggestions', route: { name: RouteName.MEMBER_LIST_SUGGESTIONS } },
    ]

    lastCompanyInfos = {}

    openFolderLocation(name: string) {
        if (this.groupLocationShow === name) {
            this.groupLocationShow = ''
        } else {
            this.groupLocationShow = name
        }
    }

    partnerUrl(slugPartner: string) {
        return `${process.env.VUE_APP_CLUB_BASE_URL}/companies/details/${slugPartner}/info`
    }

    infosHubFromId(id: string | number) {
        if (!this.config) return
        return this.config.hubs.find(value => {
            if (value.id === id) {
                return value.slug
            }
        })
    }

    get config(): Header | null {
        return this.$store.state.app.headerConfiguration
    }

    get partnersUrl() {
        return `${process.env.VUE_APP_CLUB_BASE_URL}/companies`
    }

    get pendingRelationshipSuggestionCount(): number {
        return this.$store.state.member?.pendingRelationshipSuggestionListPager?.nbMaxResults || 0
    }

    get hubs() {
        const regions = ['EMEA', 'APAC', 'AMERICAS']
        return (
            this.config &&
            regions.map(region => ({
                name: region,
                children:
                    this.config &&
                    this.config.hubs
                        .filter(hub => hub.region.toLowerCase() === region.toLowerCase())
                        .map(hub => ({
                            name: hub.name.replace('Asie du Sud-Est', 'Asie SE'),
                            route: {
                                name: RouteName.HUB_SINGLE,
                                params: {
                                    hub: hub.slug,
                                },
                            },
                        })),
            }))
        )
    }

    get clubs(): { id: number | string; name: string; slug: string }[] | null {
        return (
            this.config &&
            this.config.clubs.filter(
                club => club.slug !== 'beta' && club.slug !== 'investor' && club.slug !== 'vc-circle'
            )
        )
    }

    get myHub(): { id: string | number; name: string; slug: string; region: string } | undefined {
        if (this.me && this.me.business_center) {
            return this.infosHubFromId(this.me.business_center.id)
        } else {
            return undefined
        }
    }

    fullHubs() {
        if (this.me && this.me.member_id) {
            this.me.member_business_centers.forEach(elem => {
                let buff: { id: string | number; name: string; slug: string; region: string } | undefined = undefined
                if ((buff = this.infosHubFromId(elem.business_center.id))) {
                    this.secondariesHub.push(buff)
                }
            })
        }
    }

    async mounted() {
        this.lastCompanyInfos = await API.getPartnerLast()
        this.$store.dispatch('member/getPendingRelationshipSuggestionList')
        this.fullHubs()
    }
}
